var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", {}, [
            _c("h4", { staticClass: "mb-0" }, [_vm._v("Начисления зарплаты")])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _vm.canEditAccruals()
                        ? _c(
                            "b-dropdown",
                            {
                              attrs: {
                                id: "dropdown-create",
                                right: "",
                                size: "sm",
                                text: "Новое",
                                variant: "success"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function() {
                                      return [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: ["fas", "plus"] }
                                        }),
                                        _vm._v(
                                          "\n              Новое\n            "
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                287373176
                              )
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate(1)
                                    }
                                  }
                                },
                                [_vm._v("Начисление Аванса")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate(2)
                                    }
                                  }
                                },
                                [_vm._v("Начисление Зарплаты")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate(3)
                                    }
                                  }
                                },
                                [_vm._v("Начисление Отпуска")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate(4)
                                    }
                                  }
                                },
                                [_vm._v("Начисление Премии")]
                              ),
                              _vm._v(" "),
                              _c("b-dropdown-divider"),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate(5)
                                    }
                                  }
                                },
                                [_vm._v("Начисление Аванса Сдельно")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate(6)
                                    }
                                  }
                                },
                                [_vm._v("Начисление Зарплаты Сдельно")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate(7)
                                    }
                                  }
                                },
                                [_vm._v("Начисление Премии Сдельно")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        { attrs: { id: "filters" } },
        [
          _c(
            "b-navbar-nav",
            [
              _c(
                "b-form",
                {
                  attrs: { inline: "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.onSearch()
                    }
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "mb-1 mr-2",
                    attrs: {
                      size: "sm",
                      debounce: "500",
                      placeholder: "Поиск"
                    },
                    model: {
                      value: _vm.filters.query,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "query", $$v)
                      },
                      expression: "filters.query"
                    }
                  }),
                  _vm._v(" "),
                  _c("month-picker", {
                    staticClass: "mb-1 mr-2",
                    attrs: {
                      label: "Период",
                      placeholder: "Выберите период",
                      "min-year": 2025,
                      clearable: true
                    },
                    model: {
                      value: _vm.filters.period,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "period", $$v)
                      },
                      expression: "filters.period"
                    }
                  }),
                  _vm._v(" "),
                  _c("organization-select", {
                    ref: "organization_select",
                    staticClass: "mb-1 mr-2",
                    attrs: {
                      id: "input-organization-select",
                      value: _vm.filters.org_id
                    },
                    on: { onSelect: _vm.onSelectOrganization }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mb-1 mr-1",
                      attrs: {
                        size: "sm",
                        variant: "outline-success",
                        type: "submit"
                      }
                    },
                    [_vm._v("\n          Применить\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "accruals",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "accruals",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          bordered: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.fields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "sticky-header": "",
          "head-variant": "light"
        },
        on: { "row-dblclicked": _vm.onRowClicked },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(active)",
            fn: function(row) {
              return [
                !row.item.active
                  ? _c("font-awesome-icon", { attrs: { icon: "times" } })
                  : _vm._e(),
                _vm._v(" "),
                row.item.active
                  ? _c("font-awesome-icon", { attrs: { icon: "check" } })
                  : _vm._e()
              ]
            }
          },
          {
            key: "cell(staffs)",
            fn: function(row) {
              return [
                row.item.staffs.length < 50
                  ? _c("div", { staticClass: "text-small" }, [
                      _vm._v(_vm._s(row.item.staffs))
                    ])
                  : _c("div", { staticClass: "text-small" }, [
                      _vm._v(_vm._s(row.item.staffs.substring(0, 70) + ".."))
                    ])
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _vm.canEditAccruals()
                  ? _c(
                      "b-btn",
                      {
                        attrs: { size: "sm", variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onEdit(row.item)
                          }
                        }
                      },
                      [_c("font-awesome-icon", { attrs: { icon: "edit" } })],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: {
          "use-router": "",
          "current-page": _vm.currentPage,
          "total-rows": _vm.totalRows,
          "per-page": _vm.perPage
        },
        on: {
          "update:currentPage": function($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function($event) {
            _vm.currentPage = $event
          },
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a84a6362", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a84a6362","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Accruals/Accruals.vue
// module id = null
// module chunks = 